module.exports = __webpack_public_path__ + "static/media/tortoisesvn.0274a6a8.png";